import { FC } from 'react'
import { FiCalendar } from 'react-icons/fi'
import { useDraftsMap } from './useDraftForPetition'
import styles from './DraftIndicator.module.scss'

interface DraftIndicatorProps {
  dropId: number
}

/**
 * Small badge that appears in the petitions table row
 * when the petition has a corresponding console draft.
 */
const DraftIndicator: FC<DraftIndicatorProps> = ({ dropId }) => {
  const { draftsMap, isLoading } = useDraftsMap()
  const draft = draftsMap.get(dropId)

  if (isLoading) {
    return <span className={styles.loadingDot} />
  }

  if (!draft) {
    return null
  }

  return (
    <span className={styles.badge} aria-label={`Console Petition #${draft.id}`} data-cooltipz-dir="top">
      <FiCalendar width={12} height={12} />
      Console
    </span>
  )
}

export default DraftIndicator
